import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { apiClient } from "../utils/const";
import { usePermissions } from "./PermissionContext";
import { sendOTP } from "../utils/otpService";


function Login() {
  const navigate = useNavigate();
  const { updatePermissions } = usePermissions();
  const [formData, setFormData] = useState({
    mobile: "",
  });
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  
  // OTP related states
  const [generatedOtp, setGeneratedOtp] = useState("");

  // Prevent body scrolling
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^[0-9]{10,15}$/;
    return mobileRegex.test(mobile);
  };

  const validateField = (name, value) => {
    let error = "";

    switch (name) {
      case "mobile":
        if (!value.trim()) {
          error = "Mobile number is required";
        } else if (!validateMobile(value.trim())) {
          error = "Please enter a valid mobile number (10-15 digits)";
        }
        break;
      default:
        break;
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Real-time validation
    const error = validateField(name, value);
    setValidationErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };


  const handleSendOTP = async () => {
    // Validate mobile number
    const error = validateField("mobile", formData.mobile);
    if (error) {
      setValidationErrors({ mobile: error });
      toast.error("Please enter a valid mobile number", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    setLoading(true);
    const otpResult = await sendOTP(formData.mobile);
    
    if (otpResult.success) {
      setGeneratedOtp(otpResult.otp);
      toast.success("OTP sent successfully to your mobile number", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      // Navigate to OTP verification page
      navigate("/otp-verification", {
        state: {
          phone: formData.mobile,
          generatedOtp: otpResult.otp
        }
      });
    } else {
      toast.error(otpResult.message || "Failed to send OTP", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    setLoading(false);
  };


    return (
    <>
      <div className="container-xxl h-100" style={{overflow: 'hidden'}}>
        <div className="row h-100 d-flex justify-content-center align-items-center">
          <div className="col-12">
            <div className="card-body p-0">
              <div className="row justify-content-center">
                <div className="col-lg-4 mb-5">
                  <div className="card">
                    <div className="card-body p-0 auth-header-box rounded-top" style={{backgroundColor: '#4B2C3B', marginTop: '1.5rem', marginBottom: '-1.5rem'}}>
                      <div className="text-center p-3">
                        <a href="index.html" className="logo logo-admin">
                          <img
                            src="assets/images/or_logo.png"
                            height={100}
                            alt="logo"
                            className="auth-logo"
                          />
                        </a>
                        <h4 className="mt-2 mb-1 fw-semibold fs-18" style={{color: '#D3AF37'}}>
                          Let's Get You Signed In
                        </h4>
                      </div>
                        </div>
                        <div className="card-body pt-3 px-4">
                        <div className="my-4">
                            <div className="form-group mb-4">
                              <label className="form-label" htmlFor="mobile">
                                Mobile Number
                              </label>
                              <input
                                type="tel"
                                inputMode="numeric"
                                maxLength="15"
                                className={`form-control text-center ${
                                  validationErrors.mobile ? "is-invalid" : ""
                                }`}
                                id="mobile"
                                name="mobile"
                                placeholder="Enter mobile number"
                                value={formData.mobile}
                                onChange={handleChange}
                                style={{ fontSize: "1.2rem", letterSpacing: "0.2em" }}
                              />
                              {validationErrors.mobile && (
                                <div className="invalid-feedback">
                                  {validationErrors.mobile}
                                </div>
                              )}
                            </div>
                            {/*end form-group*/}
                            
                            <div className="form-group mb-0 row">
                              <div className="col-12">
                                <div className="d-grid mt-3">
                                  <button
                                    className="btn"
                                    type="button"
                                    onClick={handleSendOTP}
                                    disabled={loading}
                                    style={{backgroundColor: '#4B2C3B', color: '#D3AF37'}}
                                  >
                                    {loading ? "Sending OTP..." : "Send OTP"}
                                    <i className="fas fa-sms ms-1" />
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="text-center mb-2 mt-4">
                            <p className="text-muted">
                              Don't have an account ?{" "}
                              <a
                                href="/register"
                                onClick={(e) => {
                                  e.preventDefault();
                                  navigate("/register");
                                }}
                                className="text-primary ms-2"
                                style={{ cursor: "pointer" }}
                              >
                                Free Register
                              </a>
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      );
    }

export default Login;
